import { PhoneCountryCodeType } from '@bus/models';
import { BusinessCustomerTypesEnum } from '../../../CustomerDataPage/customerDataPage.model';
import { MockSearchCustomerItem, MockSearchCustomerPaginatedData } from './formModel';

export const mockCustomerData: MockSearchCustomerPaginatedData = {
  pageSize: 2,
  pages: [
    [
      {
        id: '1',
        businessCustomerType: BusinessCustomerTypesEnum.ltd,
        legalName: 'Acme Trading Ltd',
        email: 'contact@acmetrading.example',
        countryCode: PhoneCountryCodeType.Ireland,
        mobileNumber: '1 234 5678',
        address: '123 Main Street',
      },
      {
        id: '2',
        businessCustomerType: BusinessCustomerTypesEnum.soleTrader,
        legalName: 'Northfield Supplies',
        email: 'hello@northfieldsupplies.example',
        countryCode: PhoneCountryCodeType.Ireland,
        mobileNumber: '21 987 6543',
        address: '456 Oak Avenue',
      },
    ],
    [
      {
        id: '3',
        businessCustomerType: BusinessCustomerTypesEnum.unlimited,
        legalName: 'Blue Horizon Services',
        email: 'support@bluehorizonservices.example',
        countryCode: PhoneCountryCodeType.Ireland,
        mobileNumber: '61 555 1234',
        address: '789 Elm Road',
      },
      {
        id: '4',
        businessCustomerType: BusinessCustomerTypesEnum.plc,
        legalName: 'Riverstone Distribution',
        email: 'team@riverstonedistribution.example',
        countryCode: PhoneCountryCodeType.Ireland,
        mobileNumber: '91 222 3333',
        address: '321 Maple Drive',
      },
    ],
    [
      {
        id: '5',
        businessCustomerType: BusinessCustomerTypesEnum.partnership,
        legalName: 'Summit Logistics Group',
        email: 'info@summitlogisticsgroup.example',
        countryCode: PhoneCountryCodeType.Poland,
        mobileNumber: '51 444 5678',
        address: '654 Pine Lane',
      },
      {
        id: '6',
        businessCustomerType: BusinessCustomerTypesEnum.other,
        legalName: 'Evergreen Business Solutions',
        email: 'admin@evergreenbusinesssolutions.example',
        countryCode: PhoneCountryCodeType.Germany,
        mobileNumber: '21 666 7777',
        address: '987 Cedar Street',
      },
    ],
  ],
};

export const getMockSearchResults = (): MockSearchCustomerItem[] => {
  return mockCustomerData.pages.flat();
};
